import * as React from "react";
export const NoRecordFoundIcon = (props: any) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={5} y={5} width={100} height={100} rx={50} fill="#D3E7FF" />
    <rect
      x={5}
      y={5}
      width={100}
      height={100}
      rx={50}
      stroke="#EEF6FF"
      strokeWidth={10}
    />
    <path
      d="M53.9154 74.5007C65.2832 74.5007 74.4987 65.2852 74.4987 53.9173C74.4987 42.5495 65.2832 33.334 53.9154 33.334C42.5475 33.334 33.332 42.5495 33.332 53.9173C33.332 65.2852 42.5475 74.5007 53.9154 74.5007Z"
      stroke="#1678F2"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.6654 76.6673L72.332 72.334"
      stroke="#1678F2"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
